import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';

const Main = styled.ul`
  padding-inline-start: 20px;
  margin-bottom: 0;
  &.hide {
    display: none;
  }
`;

interface OutlineParagraphIdeaBulletListProps extends BaseOutlineParagraphProps {}

export const OutlineParagraphIdeaBulletList = (props: OutlineParagraphIdeaBulletListProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const isAllListItemEmpty =
    element.children
      .map((listItemNode) => listItemNode?.children?.[0]?.text || '')
      .join('')
      .trim().length === 0;
  return (
    <Main
      {...attributes}
      className={cl(
        'outline-paragraph-idea-bullet-list-element',
        { hide: isAllListItemEmpty && isReadOnly },
        element.id
      )}
    >
      {children}
    </Main>
  );
};
